import apiClient from './api_client_requests';

export default async (payload) => {
    let result = await apiClient.apiMethod({
        method: 'GetConfig',
        args: {},
    });

    return result;
};
